/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_View1Inputs */

const vi_cmstools_view1 = /** @type {(inputs: Cmstools_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

/**

* @param {Cmstools_View1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_view1 = /** @type {((inputs?: Cmstools_View1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_View1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_view1(inputs)
});
export { cmstools_view1 as "cmsTools_view" }